// extracted by mini-css-extract-plugin
export var background = "styles-module--background--5b3f4";
export var container = "styles-module--container--578be";
export var foreground = "styles-module--foreground--3ebe3";
export var imgDesktop = "styles-module--imgDesktop--efe77";
export var imgMobile = "styles-module--imgMobile--1180a";
export var overlay = "styles-module--overlay--9c3f4";
export var text = "styles-module--text--3de73";
export var wrapper = "styles-module--wrapper--caf10";